// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1de36fb0","455":"128d15de","977":"ffe2bb1c"}[chunkId] + ".chunk.js";
};